// extracted by mini-css-extract-plugin
export default {"wrap":"hYV_j7sM5Qt6slDlZvZG"};